import {
  ColumnDensity,
  ColumnPreferencesConfig,
  PatientPreferences,
} from '@common/types';
import { GridDensity } from '@mui/x-data-grid-pro';

export const TableHeaderHeight = 56;

export const TableColumnHeightMapper: Record<ColumnDensity, number> = {
  comfortable: 72,
  compact: 52,
  dense: 36,
};

export const getTableJustifyContent = (
  display?: ColumnPreferencesConfig['column_display'],
) => {
  switch (display) {
    case 'pin_right':
      return 'flex-end';
    case 'pin_left':
      return 'flex-start';
    default:
      return 'flex-start';
  }
};

export const convertGridDensityToPreferencesDensity = (
  density?: GridDensity,
): PatientPreferences['density'] => {
  switch (density) {
    case 'compact':
      return 'dense';
    case 'standard':
      return 'compact';
    default:
      return 'comfortable';
  }
};

export const convertPreferencesDensityToGridDensity = (
  density?: PatientPreferences['density'],
): GridDensity => {
  switch (density) {
    case 'dense':
      return 'compact';
    case 'compact':
      return 'standard';
    default:
      return 'comfortable';
  }
};
